import { toast } from "react-toastify";
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

export const showFailureToast = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  });
};

export const startLoadingToast = (message) => {
  const toastId = toast.loading(message, {
    position: "top-right",
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: false,
  });
  return toastId;
};

export const resolveLoadingToast = (toastId, message) => {
  toast.update(toastId, {
    type: "success",
    isLoading: false,
    render: message,
    autoClose: 5000,
    closeOnClick: true,
  });
};

export const rejectLoadingToast = (toastId, message) => {
  toast.update(toastId, {
    type: "error",
    isLoading: false,
    render: message,
    autoClose: 5000,
    closeOnClick: true,
  });
};
